/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';

const state = {
  blacklistItem: {
    createdBy: {},
  },
  error: null,
};

const getters = {
  blacklistItem: state => state.blacklistItem,
  error: state => state.error,
};

const actions = {
  fetch({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/blacklists/${payload.id}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
  save({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    let request = '';
    if (payload.blacklistItem.id) {
      request = Vue.http.put(`${process.env.BACKEND_API_URL}api/${path}/blacklists/${payload.blacklistItem.id}`, payload.blacklistItem);
    } else {
      request = Vue.http.post(`${process.env.BACKEND_API_URL}api/${path}/blacklists`, payload.blacklistItem);
    }
    return request
      .then((response) => {
        commit(mTypes.DATA_STORED, response);
      })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  delete({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/${path}/blacklists/${payload.id}`)
      .then(() => {})
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  deleteBulk({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/${path}/blacklists/bulk`, { params: { ids: payload.ids, _method: 'DELETE' } })
      .then(() => {})
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, blacklistItem) {
    state.blacklistItem = blacklistItem.data;
    state.error = null;
  },
  [mTypes.CLEAR_STATE](state) {
    state.blacklistItem = {};
  },
  [mTypes.DATA_STORED](state, blacklistItem) {
    state.blacklistItem = blacklistItem.data;
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error === null ? error : error.data.message;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/blacklist/blacklist.js